@if ((hidePanels$ | async) !== true) {
    <mat-toolbar class="toolbar">
        <div class="logo-container" [ngClass]="{ dev: !production, expanded: menuExpanded && (isMobile$ | async) !== true }">
            <div class="logo-wrapper">
                <img class="sewio-logo" src="/assets/logos/white.full.svg" alt="logo" />
            </div>
        </div>
        <div class="toolbar-right-wrapper">
            <div class="header-label">
                <mat-chip-listbox class="ml-2">
                    @if (onprem) {
                        <mat-chip class="unselectable" color="primary" (click)="deploymentClicked($event)">On-Premise</mat-chip>
                    }
                </mat-chip-listbox>
            </div>
            @if ((isMobile$ | async) === false) {
                <div class="selected-item-display-wrapper mr-1">
                    <div>
                        <div class="selected-item-display-label">SITE</div>
                        <div class="selected-item-display font-normal">
                            {{ (selectedSiteName$ | async) || '' }}
                        </div>
                    </div>
                    <div class="toolbar-horizontal-divider mx-3"></div>
                    <div>
                        <div class="selected-item-display-label">COMPANY</div>
                        <div class="selected-item-display font-normal">
                            {{ (selectedCompanyName$ | async) || '' }}
                        </div>
                    </div>
                    @if (currentLicense$ | async; as license) {
                        <div class="toolbar-horizontal-divider mx-3"></div>
                        <div>
                            <div class="selected-item-display-label">LICENSE</div>
                            @if (!isLicenseExpired(license.expiration)) {
                                <div class="selected-item-display font-normal">
                                    {{ license.type | replaceString: versionRegexp : '' }}
                                    <span class="ml-1" [ngClass]="{ 'text-warning': isLicenseExpiring(license.expiration, hidePanels$ | async) }"
                                        >[{{ license.expiration | unixTimeToDate: 'YYYY/MM/DD' }}]</span
                                    >
                                </div>
                            }
                            @if (isLicenseExpired(license.expiration) && license.expiration !== 0) {
                                <div class="selected-item-display font-normal text-error">
                                    {{ license.type | replaceString: versionRegexp : '' }}
                                    [{{ license.expiration | unixTimeToDate: 'YYYY/MM/DD' }}]
                                </div>
                            }
                            @if (isLicenseExpired(license.expiration) && license.expiration === 0) {
                                <div class="selected-item-display font-normal text-error">Not Activated</div>
                            }
                        </div>
                    }
                </div>
            }
            @if (isMobile$ | async) {
                <button mat-icon-button (click)="toggleMenu()">
                    <mat-icon>menu</mat-icon>
                </button>
            } @else {
                @if (user$ | async; as user) {
                    <div class="profile-button-container">
                        <div [matMenuTriggerFor]="profileMenu" class="rounded-full cursor-pointer ml-2">
                            <span class="profile-button-content">
                                <myrtls-profile-picture [src]="user.picture" [size]="'small'" [rounded]="true"></myrtls-profile-picture>
                                <span class="profile-button-email ml-2">
                                    {{ user['https://sewio.net/email'] || user['email'] }}
                                </span>
                            </span>
                        </div>
                        <mat-menu #profileMenu="matMenu" xPosition="before">
                            <div class="profile-menu-header" (click)="$event.stopPropagation()">
                                {{ user['https://sewio.net/email'] || user['email'] }}
                            </div>
                            <button mat-menu-item (click)="logOut()">
                                <mat-icon aria-hidden="true">logout</mat-icon>
                                Log Out
                            </button>
                            @if (version$ | async; as version) {
                                <div class="version">
                                    {{ version }}
                                </div>
                            }
                        </mat-menu>
                    </div>
                }
            }
        </div>
    </mat-toolbar>
} @else {
    <div class="full-size">
        <router-outlet></router-outlet>
    </div>
}
@if ((hidePanels$ | async) !== true) {
    <mat-sidenav-container [ngClass]="{ mobile: isMobile$ | async }" [autosize]="true">
        <mat-sidenav
            class="sidenav-container"
            [ngClass]="{ expanded: menuExpanded, hidden: menuHidden, mobile: isMobile$ | async }"
            [disableClose]="true"
            [opened]="isMenuOpen"
            [mode]="(isMobile$ | async) ? 'over' : 'side'"
            [autoFocus]="false"
            (openedChange)="isMenuOpen = $event"
        >
            <div class="sidenav-content">
                @if (isMobile$ | async) {
                    <div class="my-1">
                        <ng-container *ngTemplateOutlet="profileMenuTemplate"></ng-container>
                        <mat-divider></mat-divider>
                        <div class="side-menu-selected-item-display">
                            <div class="selected-item-display-label">COMPANY</div>
                            <div class="selected-item-display font-normal">
                                {{ (selectedCompanyName$ | async) || '' }}
                            </div>
                        </div>
                        <div class="side-menu-selected-item-display">
                            <div class="selected-item-display-label">SITE</div>
                            <div class="selected-item-display font-normal">
                                {{ (selectedSiteName$ | async) || '' }}
                            </div>
                        </div>
                        @if (currentLicense$ | async; as license) {
                            <div class="side-menu-selected-item-display">
                                <div class="selected-item-display-label">LICENSE</div>
                                @if (!isLicenseExpired(license.expiration)) {
                                    <div class="selected-item-display font-normal">
                                        {{ license.type | replaceString: versionRegexp : '' }}
                                        <span class="ml-1" [ngClass]="{ expiring: isLicenseExpiring(license.expiration, hidePanels$ | async) }"
                                            >[{{ license.expiration | unixTimeToDate: 'YYYY/MM/DD' }}]</span
                                        >
                                    </div>
                                }
                                @if (isLicenseExpired(license.expiration)) {
                                    <div class="selected-item-display font-normal">
                                        Expired [{{ license.expiration | unixTimeToDate: 'YYYY/MM/DD' }}]
                                    </div>
                                }
                            </div>
                        }
                        <mat-divider></mat-divider>
                    </div>
                }
                @for (menuCategory of menuCategories$ | async; track menuCategory) {
                    <div>
                        @if (menuCategory.name) {
                            <div class="category-header" [ngClass]="{ dev: !production, expanded: menuExpanded || (isMobile$ | async) === true }">
                                <!--mat-icon class="category-header-icon" fontSet="material-icons-outlined">{{ menuCategory.icon }}</mat-icon-->
                                <div
                                    class="category-header-text text-dark-900"
                                    [style.visibility]="menuExpanded || (isMobile$ | async) === true ? 'visible' : 'hidden'"
                                >
                                    {{ menuCategory.name | uppercase }}
                                </div>
                                @if (menuCategory.name === 'Insights') {
                                    <div class="category-header-badge font-light text-xs">new</div>
                                }
                                <div class="category-header-line text-dark-500"></div>
                            </div>
                        }
                        <div class="p-2 gap-1 flex flex-col">
                            @for (menuItem of menuItems$ | async | filterByProperty: 'category' : menuCategory.name; track menuItem) {
                                @if (!menuItem.hidden) {
                                    <myrtls-menu-item
                                        #rla="routerLinkActive"
                                        [routerLink]="menuItem.external || menuItem.state !== FeatureState.ENABLED ? undefined : menuItem.link"
                                        (click)="menuItemClick($event, menuItem)"
                                        [icon]="menuItem.icon"
                                        [title]="menuItem.label"
                                        [category]="menuCategory.name"
                                        [active]="rla.isActive"
                                        [badge]="menuCategory.name === 'Insights'"
                                        [about]="menuItem.about"
                                        [expanded]="menuExpanded"
                                        [state]="menuItem.state"
                                        [routerLinkActive]="menuItem.external || menuItem.state !== FeatureState.ENABLED ? '' : 'active'"
                                    ></myrtls-menu-item>
                                }
                            }
                        </div>
                        <!-- <mat-list>
                  <div *ngFor="let menuItem of menuItems$ | async | filterByProperty: 'category':menuCategory.name">
                    <mat-list-item
                      *ngIf="!menuItem.hidden"
                      class="sidenav-item"
                      [routerLink]="menuItem.external || menuItem.state !== FeatureState.ENABLED ? undefined : menuItem.link"
                      (click)="menuItemClick($event, menuItem)"
                      [matTooltipDisabled]="menuExpanded"
                      [matTooltip]="getMenuItemTooltip(menuItem.label, menuItem.state)"
                      [matTooltipPosition]="'right'"
                      >
                      <div class="menu-item-container" [ngClass]="{ disabled: menuItem.state !== FeatureState.ENABLED }" [routerLinkActive]="menuItem.external || menuItem.state !== FeatureState.ENABLED ? '' : 'active'">
                        <mat-icon matListIcon class="sidenav-item-icon" fontSet="material-icons-outlined">{{ menuItem.icon }}</mat-icon>
                        <mat-icon *ngIf="!menuExpanded && menuItem.state !== FeatureState.ENABLED" class="locked-icon wrapped" (click)="iconClick($event, menuItem.state !== FeatureState.ENABLED)" [matTooltipPosition]="'right'" [matTooltip]="getIconTooltip(menuItem.state)" [color]="'warn'"
                          >{{ getIcon(menuItem.state) }}
                        </mat-icon>
                        <h3 class="menu-item-label" matLine>
                          {{ menuItem.label }}
                        </h3>
                      </div>
                      <mat-icon *ngIf="menuExpanded && menuItem.state !== FeatureState.ENABLED" (click)="iconClick($event, menuItem.disabled)" [matTooltipPosition]="'right'" [matTooltip]="getIconTooltip(menuItem.state)" [color]="'warn'">{{ getIcon(menuItem.state) }}</mat-icon>
                    </mat-list-item>
                  </div>
                </mat-list> -->
                    </div>
                }
            </div>
            <button
                mat-flat-button
                disableRipple
                class="sidenav-expand-toggle-button"
                [ngClass]="{ expanded: menuExpanded }"
                (click)="toggleMenuExpand()"
            >
                <mat-icon>double_arrow</mat-icon>
            </button>
        </mat-sidenav>
        <mat-sidenav-content id="sidenav-content" class="sidenav-content">
            <router-outlet></router-outlet>
        </mat-sidenav-content>
    </mat-sidenav-container>
}

<ng-template #profileMenuTemplate>
    @if (user$ | async; as user) {
        <div class="profile-button-container">
            <div [matMenuTriggerFor]="profileMenu" class="rounded-full cursor-pointer ml-2">
                <span class="profile-button-content">
                    <myrtls-profile-picture [src]="user.picture" [size]="'small'" [rounded]="true"></myrtls-profile-picture>
                    <span class="profile-button-email ml-2">
                        {{ user['https://sewio.net/email'] || user['email'] }}
                    </span>
                </span>
            </div>
            <mat-menu #profileMenu="matMenu" xPosition="before">
                <div class="profile-menu-header" (click)="$event.stopPropagation()">
                    {{ user['https://sewio.net/email'] || user['email'] }}
                </div>
                <button mat-menu-item (click)="logOut()">
                    <mat-icon aria-hidden="true">logout</mat-icon>
                    Log Out
                </button>
                @if (version$ | async; as version) {
                    <div class="version">
                        {{ version }}
                    </div>
                }
            </mat-menu>
        </div>
    }
</ng-template>

@if (showEasterEgg) {
    <ng-particles [options]="particlesOptions" [particlesInit]="particlesInit" (particlesLoaded)="particlesLoaded($event)"></ng-particles>
}
